import React from 'react';
import AccordionDetails from '@mui/material/AccordionDetails';
import 'app/components/AccordionCustom/AttachDetails/textarea.module.css';
import AttachDetailsComponent from 'app/components/AccordionCustom/AttachDetailsComponent';

import logger from 'app/utils/logger';

interface DetailsProps {
  type: string;
  value: any;
  register?: any;
  errors?: any;
  file?: any;
  onDrop?: any;
  deleteFile?: any;
  errorFileSize?: boolean;
  values?: any;
  avans?: any;
  handleSwitchAvans?: any;
  dataForm?: any;
  handleSwitchEdv?: any;
  valueTaxEnabled?: any;
  handleChangeInvoiceNo?: any;
  invoiceValue?: any;
  selectedCountry?: any;
  valueTextArea?: any;
  handleChangeTextArea?: any;
  contractNumberRequired?: any;
  selectedAccount?: any;
}
const AttachDetails = (props: DetailsProps) => {
  const {
    type,
    value,
    errors,
    register,
    file,
    onDrop,
    deleteFile,
    errorFileSize,
    values,
    handleSwitchAvans,
    avans,
    dataForm,
    handleSwitchEdv,
    valueTaxEnabled,
    handleChangeInvoiceNo,
    invoiceValue,
    selectedCountry,
    valueTextArea,
    handleChangeTextArea,
    contractNumberRequired,
    selectedAccount,
  } = props;

  return (
    <AccordionDetails sx={{ padding: '0px 28px 32px', marginTop: '4px' }}>
      {type === 'payment_acc2acc' && (
        <AttachDetailsComponent
          register={register}
          errors={errors}
          dataForm={dataForm}
          maxLength={140}
          valueTextArea={valueTextArea}
          handleChangeTextArea={handleChangeTextArea}
        />
      )}
      {type === 'payment_interbank' && (
        <AttachDetailsComponent
          fileSize={'30 MB'}
          attachment={true}
          register={register}
          errors={errors}
          contractNumber={true}
          file={file}
          onDrop={onDrop}
          deleteFile={deleteFile}
          errorFileSize={errorFileSize}
          fileName={{
            ...register('fileInBank', { value: values('fileInBank') === undefined ? '' : values('fileInBank') }),
          }}
          dataForm={dataForm}
          maxLength={
            contractNumberRequired === 'true' && selectedAccount?.currency === 'RUB'
              ? 105
              : contractNumberRequired === 'true' &&
                selectedAccount?.currency !== 'RUB' &&
                selectedAccount?.currency !== undefined
              ? 116
              : contractNumberRequired === 'false' && selectedAccount?.currency === 'RUB'
              ? 129
              : 140
          }
          valueTextArea={valueTextArea}
          handleChangeTextArea={handleChangeTextArea}
        />
      )}
      {type === 'payment_local_transfer' && (
        <AttachDetailsComponent
          fileSize={'30 MB'}
          register={register}
          errors={errors}
          contractNumber={true}
          attachment={true}
          file={file}
          onDrop={onDrop}
          deleteFile={deleteFile}
          errorFileSize={errorFileSize}
          fileName={{
            ...register('fileInBank', { value: values('fileInBank') === undefined ? '' : values('fileInBank') }),
          }}
          edv={value?.value !== 'IPS_MT'}
          handleSwitchEdv={handleSwitchEdv}
          valueTaxEnabled={valueTaxEnabled}
          values={values}
          maxLength={116}
          valueTextArea={valueTextArea}
          handleChangeTextArea={handleChangeTextArea}
          dataForm={dataForm}
        />
      )}
      {type === 'payment_foreign_transfer' && (
        <AttachDetailsComponent
          fileSize={'30 MB'}
          attachment={true}
          avans={true}
          avansValue={avans}
          handleSwitchAvans={handleSwitchAvans}
          register={register}
          errors={errors}
          file={file}
          onDrop={onDrop}
          deleteFile={deleteFile}
          errorFileSize={errorFileSize}
          fileName={{
            ...register('fileInBank', { value: values('fileInBank') === undefined ? '' : values('fileInBank') }),
          }}
          handleChangeInvoiceNo={handleChangeInvoiceNo}
          invoiceValue={invoiceValue}
          maxLength={
            avans && selectedCountry?.value === 'RUS' ? 83 : avans ? 107 : selectedCountry?.value === 'RUS' ? 92 : 116
          }
          valueTextArea={valueTextArea}
          handleChangeTextArea={handleChangeTextArea}
          dataForm={dataForm}
        />
      )}
      {type === 'payment_edv' && (
        <AttachDetailsComponent
          fileSize={'30 Mb'}
          register={register}
          contractNumber={false}
          errors={errors}
          maxLength={140}
          valueTextArea={valueTextArea}
          handleChangeTextArea={handleChangeTextArea}
          dataForm={dataForm}
        />
      )}
      {type === 'payment_budget' && (
        <AttachDetailsComponent
          fileSize={'30 Mb'}
          register={register}
          errors={errors}
          maxLength={140}
          valueTextArea={valueTextArea}
          handleChangeTextArea={handleChangeTextArea}
          dataForm={dataForm}
        />
      )}
      {type === 'credit' && <AttachDetailsComponent />}
    </AccordionDetails>
  );
};

export default AttachDetails;
